var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "352fc2af-1eeb-4101-b1a7-73b49ff44292",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".\\38 a7548ac-dbc4-4233-aa36-6a381b59b0de{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    className: "8a7548ac-dbc4-4233-aa36-6a381b59b0de",
    d: "M30.5723,1.7188a21.8984,21.8984,0,0,1,11.709,11.709A21.5684,21.5684,0,0,1,44,22a21.5684,21.5684,0,0,1-1.7187,8.5723,21.8984,21.8984,0,0,1-11.709,11.709A21.5653,21.5653,0,0,1,22,44a21.5611,21.5611,0,0,1-8.5723-1.7187,21.8984,21.8984,0,0,1-11.709-11.709A21.5581,21.5581,0,0,1,0,22a21.5581,21.5581,0,0,1,1.7188-8.5723,21.8984,21.8984,0,0,1,11.709-11.709A21.5611,21.5611,0,0,1,22,0,21.5653,21.5653,0,0,1,30.5723,1.7188ZM24.1914,14.5664a3.1122,3.1122,0,0,0,0-4.3828,3.0938,3.0938,0,0,0-5.2852,2.1914,3.0991,3.0991,0,0,0,5.2852,2.1914ZM24.75,17.875h-5.5v16.5h5.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.80b09356b71e3ff43a19001f9a8e28f1.svg";
export { ForwardRef as ReactComponent };